export default {
  name: '',
  surname: '',
  nationality: '',
};
